import { useCallback, useState } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useSendVerificationEmail } from 'src/app/shared/hooks/payments';

import { useModalConfirmationContext } from '../../../ModalConfirmationContext';

type Result = ModelHookResult<
	{
		display: boolean;
		showContinueAsGuest: boolean;
		resendEmailResult: undefined | 'error' | 'success';
		ariaLabel: string;
		title: string;
	},
	{
		resendVerificationEmail: () => Promise<void>;
		closeModal: () => void;
	}
>;

export function useEmailVerificationModalBody(): Result {
	const [{ modalOptions }, { handleModalResult }] = useModalConfirmationContext();
	const [resendEmailResult, setResendEmailResult] = useState<undefined | 'error' | 'success'>(undefined);
	const sendVerificationEmail = useSendVerificationEmail();
	const { translate } = useI18n();

	const options = modalOptions?.type === 'emailVerification' ? modalOptions : null;
	const path = options?.path ?? '';
	const userId = options?.userId ?? '';

	return {
		data: {
			display: options !== null,
			showContinueAsGuest: options?.showContinueAsGuest ?? false,
			resendEmailResult,
			ariaLabel: translate('fe.pages.sponsors.verify_email.verify_email'),
			title: translate('fe.pages.sponsors.verify_email.verify_email'),
		},
		actions: {
			resendVerificationEmail: useCallback(async () => {
				setResendEmailResult(undefined);
				setResendEmailResult((await sendVerificationEmail(path, userId)) ? 'success' : 'error');
			}, [sendVerificationEmail, path, userId]),
			closeModal: useCallback(() => {
				setResendEmailResult(undefined);
				handleModalResult(undefined);
			}, [handleModalResult]),
		},
	};
}
